import { useQuery } from '@apollo/client';
import { useMemo } from 'react';
import { graphql } from 'src/generated';
import { client } from 'src/requests/apolloClient';

export const boardDoc = graphql(`
  query Boards {
    boards {
      _id
      name
      icon
      pinned
      createdAt
      updatedAt
      tables {
        _id
        name
        board
        views {
          _id
          type
          title
        }
      }
    }
  }
`);

export const useBoardsQuery = () => {
  const { data, loading, error } = useQuery(boardDoc);

  const boards = useMemo(() => sortBoards(data?.boards), [data]);

  return {
    boards,
    isBoardsLoading: loading,
    boardsError: error,
  };
};

export const fetchBoards = async () => {
  try {
    const { data } = await client.query({ query: boardDoc });
    return sortBoards(data?.boards);
  } catch {
    return [];
  }
};

const sortBoards = (boards?: any[]) => {
  if (!boards) return [];
  return [...boards].sort((a: any, b: any) => b.pinned - a.pinned);
};
